<template>
  <p>All participants for the program will show here</p>
  <ul>
    <li v-for="participant in this.participants" :key="participant.id">
      <router-link :to="pageLink(participant.id)">
        {{ participant.firstName }} {{ participant.lastName }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  inject: ['participantData'],
  data() {
    return {
      participants: this.participantData
    }
  },
  methods: {
    pageLink(theID) {
      return '/participants/' + theID;
    }
  }
};
</script>

<style>
ul {
  margin-top: 30px;
  list-style: none;
  padding: 0;
}

ul li {
  font-weight: 700;
  color: var(--black);
  padding: 20px 0;
  border-bottom: 1px solid #CCC;
}

ul li:last-child {
  border-bottom: none;
}

ul li a {
  text-decoration: none;
  color: inherit;
}
</style>